import DateFormatEnum from "constants/DateFormatEnum";
import IconNameEnum from "constants/IconNameEnum";
import it from "date-fns/locale/it";
import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import MaskedInput from "react-text-mask";
import FormatUtility from "utilities/FormatUtility";
import BaseIcon from "./BaseIcon";
import InfoIcon from "./InfoIcon";
import RequiredIcon from "./RequiredIcon";
registerLocale("it", it);

interface IProps {
    controlId: string;
    id?: string;
    label?: string;
    name: string;
    bottomElem?: JSX.Element;
    prepend?: JSX.Element;
    append?: JSX.Element;
    className?: string;
    placeholder?: string;
    min?: Date;
    max?: Date;
    value: string | Date;
    onFocusHandler?: (name: string, value: any) => void;
    onChangeHandler?: (name: string, value: any) => void;
    onBlurHandler?: (name: string, value: any) => void;
    required?: boolean;
    infoCode?: string;
    showCalendar: boolean;
    format?: DateFormatEnum.ISO_MONTHYEAR;
    isInvalid: boolean;
    error?: string;
    disabled?: boolean;
    autocomplete?: string;
    floatingLabel?: boolean;
    fullWidth?: boolean;
}
interface IState {
    readonly autocomplete: string;
}
//const stateFormat = DateFormatEnum.ITA_DATE;
//const calendarFormat = DateFormatEnum.ISO_DATE;
//const inputFormat = DateFormatEnum.ITA_DATE;
//const mask = [/[0-3]/, /\d/, "/", /[0-1]/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/];

class BaseDate extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            autocomplete: this.props.autocomplete ?? "off",
        } as IState;
    }

    private getInputFormat = () => {
        let result = DateFormatEnum.ITA_DATE;
        switch (this.props.format) {
            case DateFormatEnum.ISO_MONTHYEAR:
                result = DateFormatEnum.ITA_MONTHYEAR;
                break;
        }
        return result;
    };

    private getInputMask = () => {
        let result = [/[0-3]/, /\d/, "/", /[0-1]/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/];
        switch (this.props.format) {
            case DateFormatEnum.ISO_MONTHYEAR:
                result = [/[0-1]/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/];
                break;
        }
        return result;
    };

    private onFocusHandler = (evt: React.FocusEvent<HTMLInputElement>) => {
        let value = evt.currentTarget.value;
        // value = FormatUtility.dateInGivenFormat(value, this.state.inputFormat);
        // evt.currentTarget.value = value;

        if (this.props.onFocusHandler != null) {
            this.props.onFocusHandler(this.props.name, value);
        }
    };

    private onChangeHandler = (evt: React.ChangeEvent<HTMLInputElement>) => {
        let value = evt.currentTarget.value;

        if (this.props.onChangeHandler != null) {
            this.props.onChangeHandler(this.props.name, value);
        }
    };

    private onBlurHandler = (evt: React.FocusEvent<HTMLInputElement>) => {
        let value = evt.currentTarget.value;
        // value = FormatUtility.dateInGivenFormat(value, this.state.stateFormat);
        // evt.currentTarget.value = value;

        // if (this.props.onChangeHandler != null) {
        //     this.props.onChangeHandler(this.props.name, value);
        // }

        if (this.props.onBlurHandler != null) {
            this.props.onBlurHandler(this.props.name, value);
        }
    };

    private onDateChangeHandler = (value: any) => {
        let formattedValue = "";
        if (value !== null && value !== undefined && value instanceof Date) {
            formattedValue = FormatUtility.dateInGivenFormat(value, this.getInputFormat());
        }
        if (this.props.onChangeHandler != null) {
            this.props.onChangeHandler(this.props.name, formattedValue);
        }
    };

    private onDateChangeRawHandler = (evt: React.FocusEvent<HTMLInputElement>) => {
        // impedisce che la data venga digitata dall'utente
        evt.currentTarget.value = this.props.value.toString();
    };

    private onCalendarClose = () => {
        if (this.props.onBlurHandler != null) {
            this.props.onBlurHandler(this.props.name, this.props.value);
        }
    };

    /* #region dismesso 
    private conformValue = (
        conformedValue: string,
        config: any
    ): string | false | { value: string; indexesOfPipedChars: number[] } => {
        //return conformedValue;

        const maxValueMonth = [31, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        const dateFormat = 'dd/mm/yyyy';
        const formatOrder = ['dd', 'mm', 'yy', 'yyyy'];
        const minYear = 1000;
        const maxYear = 2999;
        const dateFormatArray = dateFormat
            .split(/[^dmy]+/)
            .sort((a, b) => formatOrder.indexOf(a) - formatOrder.indexOf(b));
        const indexesOfPipedChars: number[] = [];
        const maxValue = { 'dd': 31, 'mm': 12, 'yy': 99, 'yyyy': maxYear }
        const minValue = { 'dd': 1, 'mm': 1, 'yy': 0, 'yyyy': minYear }
        const conformedValueArr = conformedValue.split('');

        // Check first digit
        dateFormatArray.forEach((format) => {
            const position = dateFormat.indexOf(format)
            const maxFirstDigit = parseInt(maxValue[format].toString().substr(0, 1), 10)

            if (parseInt(conformedValueArr[position], 10) > maxFirstDigit) {
                conformedValueArr[position + 1] = conformedValueArr[position]
                conformedValueArr[position] = "0"
                indexesOfPipedChars.push(position)
            }
        });
        
        // Check for invalid date
        let month = 0
        const isInvalid = dateFormatArray.some((format) => {
            const position = dateFormat.indexOf(format)
            const length = format.length
            const textValue = conformedValue.substr(position, length).replace(/\D/g, '')
            const value = parseInt(textValue, 10)
            if (format === 'mm') {
                month = value || 0
            }
            const maxValueForFormat = format === 'dd' ? maxValueMonth[month] : maxValue[format]
            if (format === 'yyyy' && (minYear !== 1000 || maxYear !== 2999)) {
                const scopedMaxValue = parseInt(maxValue[format].toString().substring(0, textValue.length), 10)
                const scopedMinValue = parseInt(minValue[format].toString().substring(0, textValue.length), 10)
                return value < scopedMinValue || value > scopedMaxValue
            }
            return value > maxValueForFormat || (textValue.length === length && value < minValue[format])
        });

        if (isInvalid) {
            return false;
        }

        return {
            value: conformedValueArr.join(''),
            indexesOfPipedChars
        };
    };
    #endregion dismesso */

    public render(): JSX.Element {
        const {
            controlId,
            id,
            label,
            bottomElem,
            prepend,
            append,
            className,
            name,
            placeholder,
            min,
            max,
            value,
            required,
            infoCode,
            isInvalid,
            error,
            showCalendar,
            format,
            disabled,
            floatingLabel,
        } = this.props;

        const { autocomplete } = this.state;

        const getValue = (): string => {
            if (value == null || value === "") {
                return "";
            }
            return value.toString();
        };

        const getDate = (): Date | undefined => {
            let valueFormatted = value;
            switch (this.props.format) {
                case DateFormatEnum.ISO_MONTHYEAR:
                    valueFormatted = "01/" + value;
                    break;
            }
            return FormatUtility.dateOrUndefined(valueFormatted);
        };

        return (
            <Form.Group className={this.props.fullWidth ? " mb-0 w-100" : "mb-0"} controlId={controlId}>
                {floatingLabel === false && label ? (
                    <Form.Label>
                        {label}
                        {required ? <RequiredIcon /> : null}
                        {infoCode ? <InfoIcon label={label} code={infoCode} /> : null}
                    </Form.Label>
                ) : null}
                <InputGroup
                    className={["rounded ccq-shadow", floatingLabel !== false ? "floating-label-container" : ""].join(
                        " "
                    )}
                >
                    {prepend ? (
                        <InputGroup.Prepend>
                            <InputGroup.Text className={["rounded-left", disabled ? "" : "bg-white"].join(" ")}>
                                {prepend}
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                    ) : null}
                    <MaskedInput
                        mask={this.getInputMask()}
                        guide={true}
                        keepCharPositions={false}
                        //pipe={(value, config) => this.conformValue(value, config)}
                        //autoCorrect={(props: Readonly<MaskedInputProps>) => this.autoCorrect(props)}
                        showMask={false}
                        className={[
                            "form-control",
                            prepend == null ? "rounded-left" : "",
                            append == null && showCalendar === false ? "rounded-right" : "",
                            isInvalid ? "is-invalid" : "",
                            className ? className : "",
                        ].join(" ")}
                        id={id || controlId}
                        type={"text"}
                        name={name}
                        value={getValue()}
                        onFocus={this.onFocusHandler}
                        onChange={this.onChangeHandler}
                        onBlur={this.onBlurHandler}
                        //isInvalid={isInvalid}
                        //custom={type === "range"}
                        // min={min instanceof Date ? moment(min).format(DateFormatEnum.ISO_DATE) : min}
                        // max={max instanceof Date ? moment(max).format(DateFormatEnum.ISO_DATE) : max}
                        //step={step}
                        placeholder={floatingLabel === false ? placeholder : placeholder || " "}
                        //autoComplete="off"
                        autoComplete={autocomplete}
                        disabled={disabled}
                    />
                    {floatingLabel !== false && label ? (
                        <Form.Label>
                            {label}
                            {required ? <RequiredIcon /> : null}
                            {infoCode ? <InfoIcon label={label} code={infoCode} /> : null}
                        </Form.Label>
                    ) : null}
                    {append ? (
                        <InputGroup.Append>
                            <InputGroup.Text className={["rounded-right", disabled ? "" : "bg-white"].join(" ")}>
                                {append}
                            </InputGroup.Text>
                        </InputGroup.Append>
                    ) : null}
                    {showCalendar === true ? (
                        <InputGroup.Append>
                            <InputGroup.Text className={["rounded-right", disabled ? "" : "bg-white"].join(" ")}>
                                <ReactDatePicker
                                    customInput={
                                        <div className={disabled ? "" : "cursor-pointer"}>
                                            <BaseIcon icon={IconNameEnum.Calendario} />
                                        </div>
                                    }
                                    selected={getDate()}
                                    //value={getValue()}
                                    minDate={min instanceof Date ? min : undefined}
                                    maxDate={max instanceof Date ? max : undefined}
                                    onChange={(date) => this.onDateChangeHandler(date)}
                                    onChangeRaw={(e) => {
                                        this.onDateChangeRawHandler(e);
                                    }}
                                    //shouldCloseOnSelect={false}
                                    //onBlur={this.onDateBlurHandler}
                                    onCalendarClose={this.onCalendarClose}
                                    dateFormat={DateFormatEnum.JS_ITA_DATE}
                                    //highlightDates={getValue() != "" ? [moment(getValue(), DateFormatEnum.ITA_DATE).toDate()] : undefined}
                                    locale="it"
                                    showYearDropdown
                                    showMonthDropdown
                                    dropdownMode="scroll"
                                    //autoComplete={autocomplete}
                                    disabledKeyboardNavigation
                                    withPortal
                                    showMonthYearPicker={format === DateFormatEnum.ISO_MONTHYEAR}
                                    disabled={disabled}
                                />
                            </InputGroup.Text>
                        </InputGroup.Append>
                    ) : null}
                    {bottomElem}
                </InputGroup>
                <Form.Control.Feedback type="invalid" className="d-block bg-transparent mt-1">
                    {error}
                </Form.Control.Feedback>
            </Form.Group>
        );
    }
}

export { BaseDate as Unconnected };
export default BaseDate;
